import { Box, Button, ButtonGroup } from '@mui/material'
import { FC } from 'react'
import { AppBar as RAAppBar, Logout, RefreshIconButton, TitlePortal, useLocaleState, UserMenu, useSetLocale } from 'react-admin'

import { availableLocales } from '@/i18n'

const LanguageSwitcher: FC = () => {
  const [locale] = useLocaleState()
  const setLocale = useSetLocale()
  return (
    <ButtonGroup size="small" variant="text" color="inherit">
      {availableLocales.map(({ locale: localeCode }) => (
        <Button
          key={localeCode}
          onClick={() => {
            setLocale(localeCode)
          }}
          sx={{
            color: 'inherit',
            fontWeight: locale === localeCode ? 'bold' : 'normal',
            textDecoration: locale === localeCode ? 'underline' : 'none',
          }}
        >
          {localeCode}
        </Button>
      ))}
    </ButtonGroup>
  )
}

export const AppBar: FC = () => {
  return (
    <RAAppBar
      color="primary"
      toolbar={
        <Box display="flex" justifyContent="space-between" width="100%">
          <TitlePortal />
          <Box display="flex" alignItems="center" gap={1}>
            <LanguageSwitcher />
            <RefreshIconButton />
            <UserMenu>
              <Logout />
            </UserMenu>
          </Box>
        </Box>
      }
      userMenu={false}
    />
  )
}
